import { Node_Type } from "./../../ricos-types/index.js";
import {
  CollapsibleListItemBodyProperty,
  CollapsibleListItemTitleProperty
} from "./collapsibleItemProperty.js";
import CollapsibleList from "./collapsibleList.js";
import CollapsibleListItem from "./collapsibleListItem.js";
const nodeViewRenderers = {
  [Node_Type.COLLAPSIBLE_LIST]: CollapsibleList,
  [Node_Type.COLLAPSIBLE_ITEM]: CollapsibleListItem,
  [Node_Type.COLLAPSIBLE_ITEM_TITLE]: CollapsibleListItemTitleProperty,
  [Node_Type.COLLAPSIBLE_ITEM_BODY]: CollapsibleListItemBodyProperty
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
